


































































































































































































































































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import UserQuestion from "../../../api/v2/models/user_question";
import { format } from "date-fns";
import VoteForm from "../../../api/v2/forms/vote";
import api from "../../../api/v2/api";
import AnswerForm from "../../../api/v2/forms/answer";
import Simplemde from "../atoms_molecules/Simplemde.vue";
import CommentCreation from "../atoms_molecules/CommentCreation.vue";
import UserAnswer from "../../../api/v2/models/user_answer";
import CommentForm from "../../../api/v2/forms/comment";
import {makeChannel, removeChannel} from '../../../../action_cable/cable'

@Component({
  components: {
    Simplemde,
    CommentCreation,
  },
})
export default class UserQuestionDetailModal extends Vue {
  @Prop({ default: true }) showCloseButton: boolean
  @Prop({ required: true }) question!: UserQuestion;
  @Prop({ required: true }) onBack!: () => void;

  currentQuession: UserQuestion | null = null;
  answerFiles: File[] = [];
  newAnswer: string = "";
  answerToggle = false;
  channel: any = null;

  async created() {
    await this.getCurrentQuestion();
    if (this.currentQuession) {
      this.createCommentChannel();
    }
  }

  async getCurrentQuestion() {
    this.currentQuession = await api.userQuestion.show(`${this.question.id}`);
  }

  dateFormat(date: Date | string) {
    return format(new Date(date), "YYYY/MM/DD HH:mm");
  }

  async upVote(voteMark, votableId, votableType) {
    if (voteMark == 1) {
      return;
    }
    try {
      const voteForm = new VoteForm();
      voteForm.value = Math.min(voteMark + 1, 1);
      voteForm.votableId = votableId;
      voteForm.votableType = votableType;
      await api.vote.create(voteForm);
      this.currentQuession = await api.userQuestion.show(
        `${this.currentQuession.id}`
      );
    } catch (e) {
    } finally {
    }
  }

  async downVote(voteMark, votableId, votableType) {
    if (voteMark == -1) {
      return;
    }
    try {
      const voteForm = new VoteForm();
      voteForm.value = Math.max(voteMark - 1, -1);
      voteForm.votableId = votableId;
      voteForm.votableType = votableType;
      await api.vote.create(voteForm);
      this.currentQuession = await api.userQuestion.show(
        `${this.currentQuession.id}`
      );
    } catch (e) {
    } finally {
    }
  }

  async createAnswer() {
    try {
      const answerForm = new AnswerForm();
      answerForm.body = this.newAnswer;
      answerForm.question_id = `${this.currentQuession.id}`;
      answerForm.materials = this.answerFiles;
      await api.answer.create(answerForm);

      this.newAnswer = "";
      this.answerFiles = [];
      this.currentQuession = await api.userQuestion.show(
        `${this.currentQuession.id}`
      );

      this.answerToggle = false;
    } catch (e) {
    } finally {
    }
  }

  async createAnswerComment(newComment: string, answer: UserAnswer) {
    try {
      const commentForm = new CommentForm();
      commentForm.body = newComment;
      commentForm.commentableId = answer.id;
      commentForm.commentableType = "Answer";
      await api.comment.create(commentForm);
      this.currentQuession = await api.userQuestion.show(
        `${this.currentQuession.id}`
      );
      answer.showCommentForm = false;
    } catch (e) {
    } finally {
    }
  }

  async createComment(newComment: string) {
    try {
      const commentForm = new CommentForm();
      commentForm.body = newComment;
      commentForm.commentableId = this.currentQuession.id;
      commentForm.commentableType = "Question";
      await api.comment.create(commentForm);
      this.currentQuession = await api.userQuestion.show(
        `${this.currentQuession.id}`
      );
      this.currentQuession.showCommentForm = false;
    } catch (e) {
    } finally {
    }
  }

  createCommentChannel() {
    removeChannel('QuestionCommentChannel')
    this.channel = makeChannel(
      'QuestionCommentChannel',
      async (e) => {
        this.getCurrentQuestion()
      },
      () => {
        this.channel.send({
          action: 'follow',
          data: {
            relativeable_id: this.currentQuession.id,
            relativeable_type: 'Question'
          }
        })
      },
    )
  }
}
